import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { NavigationService } from '../../services/navigation.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'offer-banner',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './offer-banner.component.html',
    styleUrl: './offer-banner.component.scss',
})
export class OfferBannerComponent {
    constructor(private navigationService: NavigationService) {}

    goToOffers() {
        this.navigationService.goToOffers();
    }
}
